module.exports = __webpack_public_path__ + "static/media/rep_dot.e15caf12.svg";